import React, { ReactNode } from 'react'

import classNames from 'classnames'

import classes from './IconBottom.module.scss'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  isOpen: boolean
  openText?: ReactNode
  closeText?: ReactNode
  withTransition?: boolean
}
export const IconBottom = ({
  isOpen,
  openText,
  closeText,
  children,
  onClick,
  withTransition = true,
  ...rest
}: Props): JSX.Element => {
  const iconClass = classNames([
    classes.arrow_down,
    'icon-arrow-down-1',
    { [classes.withTransition]: withTransition, [classes.rotate]: isOpen },
  ])

  return (
    <div className={classes.more} {...rest}>
      <div className={classes.more_container} onClick={onClick}>
        {!isOpen ? openText : closeText}
        <i className={iconClass}></i>
      </div>

      {children}
    </div>
  )
}
